import { render, staticRenderFns } from "./AddReceiverToGradualMessage.vue?vue&type=template&id=d34398d2&"
import script from "./AddReceiverToGradualMessage.vue?vue&type=script&lang=js&"
export * from "./AddReceiverToGradualMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports